const MemberList = () => import('@/pages/member-setting/MemberList');
const MemberSpec = () => import('@/pages/member-setting/MemberSpec');
const PurchaseRecord = () => import('@/pages/member-setting/PurchaseRecord');
const MemberSetting = () => import('@/pages/member-setting/MemberSetting');

export default [
  {
    path: '/member-list',
    component: MemberList,
    meta: [
      {
        name: 'VIP管理',
        url: '',
      },
      {
        name: 'VIP列表',
        url: '',
      },
    ],
  },
  {
    path: '/member-spec',
    component: MemberSpec,
    meta: [
      {
        name: 'VIP管理',
        url: '',
      },
      {
        name: 'VIP列表',
        url: '/member-list',
      },
      {
        name: '规格',
        url: '',
      },
    ],
  },
  {
    path: '/purchase-record',
    component: PurchaseRecord,
    meta: [
      {
        name: 'VIP管理',
        url: '',
      },
      {
        name: '购买记录',
        url: '',
      },
    ],
  },
  {
    path: '/member-setting',
    component: MemberSetting,
    meta: [
      {
        name: 'VIP管理',
        url: '',
      },
      {
        name: 'VIP设置',
        url: '',
      },
    ],
  },
]
